/**
 * Date Range Field Type
 *
 * Provides configuration for date range fields.
 * Uses the same renderers as date fields (via dateReadOnly/dateEditable in the registry).
 */

import type { FieldTypeConfig } from '../../types';
import { M } from './columnWidths';

// ============================================================================
// Field Type Configuration
// ============================================================================

/**
 * Date range field type configuration
 * Uses the same renderers as date fields (via the registry)
 */
export const dateRangeFieldType: FieldTypeConfig = {
  placeholder: 'Select date range...',
  ...M,
};
